export enum CampaignReturnableItemOption
{
    No = 1,
    Yes = 2,
    InOriginalPackageUnit = 3,
    MultiplesOfThePackingUnit = 4
}

(CampaignReturnableItemOption as any).__typeName = 'CampaignReturnableItemOption';
